import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import "./css/InverterSelectorForm.css";
import { CapacityView } from "./CapacityView";
import PhaseView from "./PhaseView";
import InputVoltageView from "./InputVoltageView";
import { OutputVoltageView } from "./OutputVoltageView";
import EnclosureView from "./EnclosureView";
import HeaderView from "./HeaderView";
import { invSelAlgo } from "../services/invSelAlgo";
import ModelSeriesSelectView from "./ModelSeriesSelectView";
import AuxBreakerView from "./AuxBreakerView";
import BatterySelectView from "./BatterySelectView";
import OptionSelectView from "./OptionSelectView";
import WarrantySelectView from "./WarrantySelectView";
import DetailedUserDataView from "./DetailedUserDataView";
import SignUpEmailView from "./SignUpEmailView";
import NavRow from "./NavRow";
import ProgressSteps from "./ProgressSteps";
// import { withStyles } from 'material-ui/styles';

const maxViewsIndex = 11;

const filePath = require("../assets/opdata.xlsx");

// const styles = theme => ({
//   title: {
//     fontFamily: 'ford-normal',
//   }
// });
export class InverterSelectorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      totalcap: "",
      allowTotal: "",
      mytotalcap: "",
      wattTotal: "",
      numFixture: "",
      phaseType: false,
      threePhase: true,
      singlePhase: true,
      phaseTypeData: "",
      cabType: "",
      shakerTable: "",
      fieldSelectableVoltdata: "",
      updateDataOnNext: false,
      productType: "",
      opdata: {},
      userOPdata: {},
      ivData: "",
      ovData: "",
      batBUTData: "90",
      batTypeData: "",
      custombatBUTData: "",
      optionList: {},
      batteryList: {},
      monitorOptions: {},
      systemTransfer: {},
      batMonList: {},
      globMonList: {},
      warrantyList: {},
      qtyMonOption: {},
      modelNumberCode: {},
      myProductNumber: {},
      userProfile: {},
      auxBreakerConfig: [],
      numOfBreakers: "",
      listSize: 1,
      modelIndex: 0,
      showNextButton: false,
      sfb1: "None",
      sfb2: "None",
    };
  }

  componentDidUpdate(prevState, prevProps) {
    //This is where you check the isCompleted Logic that you will add to each of the Set states for options data reading from excel.

    // Check if both monitorOptions and systemTransfer were not loaded before, and are now
    if (
      !prevState.isMonitorOptionsLoaded &&
      !prevState.isSystemTransferLoaded &&
      this.state.isMonitorOptionsLoaded &&
      this.state.isSystemTransferLoaded
    ) {
      //this.runMyFunction(); // Replace this with your actual function
    }
  }

  componentDidMount() {
    this.setOPData();
  }
  setShowNextButton = (bool) => {
    this.setState({ showNextButton: bool });
  };

  setShowPrevButton = (bool) => {
    //console.log(bool);
    this.setState({ showPrevButton: bool });
  };
  //Call this func to reset the op
  setOPData() {
    console.log("SETOPDATA");
    invSelAlgo(filePath, 0)
      .then((data) => {
        this.setState({ opdata: data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //Set the opdata with the data
  setOpdatawithProduct(data) {
    //console.log("set opdatawith product");
    this.setState({ userOPdata: data }, () => {
      //Change show button after set state on useropdata completes
      //this.setShowNextButton(true);
      //alert("Test")
      //this.next()
    });
  }

  /* change this to Set Power Rating */
  powerRatingFilteredData = (prval) => {
    //Set the total Cap with the tol
    this.setState({ totalcap: prval }, () => {
      if (prval < 1900 && prval > 490) {
        this.setState({ phaseTypeData: 1 });
        this.setState({ phaseType: true });
        this.setState({ singlePhase: false });
        this.setState({ threePhase: true });
      }

      if (prval < 490) {
        this.setState({ phaseTypeData: 1 });
        this.setState({ phaseType: true });
        this.setState({ singlePhase: false });
        this.setState({ threePhase: true });
      }

      if (prval > 7800) {
        this.setState({ threePhase: true });
        this.setState({ singlePhase: false });
        this.setState({ phaseType: true });
        this.setState({ phaseTypeData: 1 });
      }
    });
  };

  saveAllowanceTotal = (data) => {
    this.setState({ allowTotal: data });
  };

  saveMyTotalCap = (data) => {
    this.setState({ mytotalcap: data });
  };

  saveNumFixture = (data) => {
    this.setState({ numFixture: data });
  };

  saveWattTotal = (data) => {
    this.setState({ wattTotal: data });
  };

  //Once phase is determined you can now filter with phase and power rating
  phaseFilteredData = (phase) => {
    //Phase = true is single phase (TRUE)
    //phase = false is three phase (FALSE)
    //This is UI Logic to show phase type input and output choices
    if (phase === 1) {
      this.setState({ singlePhase: false });
      this.setState({ threePhase: true });
      this.setState({ phaseType: true });
      this.setState({ phaseTypeData: 1 });
    } else {
      this.setState({ threePhase: false });
      this.setState({ singlePhase: true });
      this.setState({ phaseType: false });
      this.setState({ phaseTypeData: 3 });
    }
  };

  //This func is called to store Input voltage selection
  setIVData = (data) => {
    this.setState({ ivData: data });
    this.setState({ cabType: "" });
    this.setState({ shakerTable: "" });
  };

  //This func is called to store output voltage selection
  setOVData = (data) => {
    this.setState({ ovData: data });
    this.setState({ cabType: "" });
    this.setState({ shakerTable: "" });
  };

  //This func is called for Battery Option time
  setbatBUTData = (data) => {
    this.setState({ batBUTData: data });
  };

  //This func is called to set battery type
  setbatTypeData = (data) => {
    this.setState({ batTypeData: data }, () => {});
  };
  setCustombatBUTData = (data) => {
    this.setState({ custombatBUTData: data });
  };

  //Set Product name and set data for Additional options based on Product Name
  setProductType = (name, index) => {
    this.setState({ productType: name });

    if (name === "Micro Power Wave") {
      this.setState({ batTypeData: "Long Life" });
    } else {
      this.setState({ batTypeData: "Standard" });
    }

    this.setState({ modelIndex: index });
    this.updateOPData(() => {});
    this.getAllProductOptions2((name) ,() => { 

      //alert("test here");
      this.next();
    });

    // setTimeout(() => {
    //   //this.setState({ showNextButton: true });
    //   //this.next();
    //   console.log("End of timer?")
    // }, 1200);
  };


  setProfileData = (_profileData) => {
    this.setState({ profileData: _profileData });
  };

  getAllProductOptions2 = (name, callback) => {
    console.log("Get all product options called here");

    this.setState((prevState) => ({
        userOPdata: prevState.userOPdata.map((item) => {
            if (item.Name === name) {
                return { ...item, Checked: true };
            } else if (item.checked) {
                return { ...item, Checked: false };
            }
            return item;
        }),
    }));

    const promises = [
        invSelAlgo(filePath, 1),
        invSelAlgo(filePath, 2),
        invSelAlgo(filePath, 3),
        invSelAlgo(filePath, 4),
        invSelAlgo(filePath, 5),
        invSelAlgo(filePath, 6),
        invSelAlgo(filePath, 7),
        invSelAlgo(filePath, 8)
    ];

    Promise.all(promises)
        .then((dataSets) => {
            dataSets.forEach((data, index) => {
                const resultObject = {};
                data.forEach((row) => {
                    const rowdata = row[name];
                    if (index === 7) { // Example for handling specific sheet with additional logic
                        const rowdataCode = row[name + " Code"];
                        if (rowdata !== undefined && rowdataCode !== undefined) {
                            resultObject[rowdata] = rowdataCode;
                        }
                    } else if (rowdata !== undefined) {
                        resultObject[rowdata] = true;
                    }
                });

                // Set state according to index if needed or adjust logic as per requirements
                const stateKeys = ['optionList', 'batteryList', 'monitorOptions', 'systemTransfer', 'batMonList', 'globMonList', 'warrantyList', 'modelNumberCode'];
                this.setState({ [stateKeys[index]]: resultObject });
            });

            console.log("All data processing completed");
            if (callback) callback(); // Call the callback function if provided
        })
        .catch((error) => {
            console.log("Error during data processing", error);
            if (callback) callback(error); // Call the callback with error if provided
        });

    console.log("End of method invocation, asynchronous tasks pending");
};

//This is the old version with out callback
  getAllProductOptions = (name) => {
    console.log("Get all product options called here");
      this.setState((prevState) => ({
        userOPdata: prevState.userOPdata.map((item) => {
          if (item.Name === name) {
            return { ...item, Checked: true };
          } else if (item.checked) {
            return { ...item, Checked: false };
          }
          return item;
        }),
      }));

    //READ FROM OPTIONS SHEET INDEX 1
    invSelAlgo(filePath, 1)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ optionList: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //READ FROM BATTERY OPTIONS SHEET 2
    invSelAlgo(filePath, 2)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ batteryList: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //READ FROM Monitoring OPTIONS SHEET 3
    invSelAlgo(filePath, 3)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ monitorOptions: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //READ FROM System Transfer OPTIONS SHEET 4
    invSelAlgo(filePath, 4)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ systemTransfer: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //READ FROM BatteryMonitoriing OPTIONS SHEET 5
    invSelAlgo(filePath, 5)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ batMonList: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //READ FROM Global Monitoriing OPTIONS SHEET 6
    invSelAlgo(filePath, 6)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ globMonList: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //Set up the Warranty Data
    //READ FROM Warranty OPTIONS SHEET 7
    invSelAlgo(filePath, 7)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          if (rowdata !== undefined) {
            resultObject[rowdata] = true;
          }
        });

        this.setState({ warrantyList: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

    //SetproductModelNumberAlgo
    invSelAlgo(filePath, 8)
      .then((data) => {
        const resultObject = {};

        data.forEach((row) => {
          const rowdata = row[name];

          const rowdataCode = row[name + " Code"];

          if (rowdata !== undefined && rowdataCode !== undefined) {
            resultObject[rowdata] = rowdataCode;
          }
        });

        this.setState({ modelNumberCode: resultObject }, () => {});
      })
      .catch((error) => {
        console.log(error);
      });

      console.log("End of reading excel")

  };

  cabinetFilteredData = (data) => {
    this.setState({ cabType: data });
    //When you set this true.. updateOPData will be called when you select Next.
  };

  shakerTableFilteredData = (data) => {
    this.setState({ shakerTable: data }, () => {

      this.updateOPData()
      // if (this.state.phaseTypeData === 1) {
      //   //console.log("This is when single phase and under 8kw");
      //   this.updateOPData();
      //   console.log("Single Phase 1")
      // }

      // if (
      //   this.state.fieldSelectableVoltdata === "true" ||
      //   this.state.fieldSelectableVoltdata === "false"
      // ) {
      //   this.updateOPData();
      //   console.log("Field Selectable is true or false")
      // }

      // console.log("shakerTableFilteredData")

    });
  };

  fieldSelectableVoltOption = (data) => {
    this.setState({ fieldSelectableVoltdata: data }, () => {
      this.updateOPData();
    });
  };

  phaseFilter() {
    //True===single phase
    console.log("PHASEFILTER");
    const ptFilteredData = this.state.opdata.filter(
      (item) => item["Phase"] === (this.state.phaseType ? 1 : 3)
    );

    return ptFilteredData;
  }

  cabinetFilter(data) {
    //Start Filter by Cabinet
    const cbFilteredData = data.filter(
      (item) => item["Cabinet"] === this.state.cabType
    );

    return cbFilteredData;
  }

  /*****  This is all the func that will set state on product options *****/
  /***********************************************************************/
  // Function to update checkboxData when a checkbox is clicked
  setOptionsList = (data) => {
    this.setState({ optionList: data }, () => {
      //console.log(this.state.optionList);
    });
  };

  setQtyMonOptionsList = (data) => {
    this.setState({ qtyMonOption: data }, () => {
      //console.log("First qtymonoptions out")
      //console.log(this.state.qtyMonOption);
    });
  };

  //Func to update the checkbox data for
  setBatOptionsList = (data) => {
    this.setState({ batteryList: data }, () => {
      //console.log(this.state.batteryList);
    });
  };

  //This is called in
  setMonOptionsList = (data) => {
    this.setState({ monitorOptions: data }, () => {
      //console.log("this needs to be correct");
      //console.log(this.state.monitorOptions);
    });
  };

  setSystemTransfer = (data) => {
    this.setState({ systemTransfer: data }, () => {
      //console.log(this.state.systemTransfer);
    });
  };

  setBatMonOptionsList = (data) => {
    this.setState({ batMonList: data }, () => {
      //console.log(this.state.batMonList);
    });
  };

  setGlobalMonList = (data) => {
    this.setState({ globMonList: data }, () => {
      //console.log(this.state.globMonList);
    });
  };

  setWarrantyList = (data) => {
    this.setState({ warrantyList: data }, () => {
      //console.log(this.state.warrantyList);
    });
  };

  //Update OPDATA whenever user selects new data for product type
  updateOPData() {
    let FilteredData = {};
    let miniPWdata = {};
    let pw3and4data = {};

    //filter by phase first
    //True===single phase
    let ptFilteredData = this.phaseFilter();

    miniPWdata = ptFilteredData;

    //Filter by Field Selectable Volatage choice
    if (
      this.state.totalcap >= 7000 &&
      this.state.totalcap < 50000 &&
      this.state.phaseTypeData === 3 &&
      this.state.cabType === "Indoor"
    ) {
      if (this.state.fieldSelectableVoltdata === "true") {
        //Power wave 4 only
        pw3and4data = miniPWdata.filter((item) => item["Name"].includes("4"));
        console.log("Power wave 4 only")
        console.log(pw3and4data)
      } else if (this.state.fieldSelectableVoltdata === "false") {
        pw3and4data = miniPWdata.filter((item) => item["Name"].includes("3"));
      } else {
        pw3and4data = miniPWdata;
      }
    } else {
      pw3and4data = miniPWdata;
    }

    //alert("CabinetFilter")
    let cbFilteredData = this.cabinetFilter(pw3and4data);

    if (this.state.shakerTable === "true") {
      FilteredData = cbFilteredData.filter(
        (item) => item["Type"] === "Shaker Table Floor Mount"
      );
    } else {
      //When Shaker table tested is NO
      //Run the filter by Indoor only
      FilteredData = cbFilteredData.filter(
        (item) => item["Type"] !== "Shaker Table Floor Mount"
      );
    }

    var minDif = 400001;
    var closetsItem = [];
    for (const item of FilteredData) {
      if (item["Power Rating"] >= this.state.totalcap) {
        const diff = item["Power Rating"] - this.state.totalcap;
        if (diff < minDif) {
          minDif = diff;
          closetsItem = [item];
        } else if (diff === minDif) {
          closetsItem.push(item);
        }
      }

      if (
        this.state.totalcap <= 500 &&
        this.state.totalcap >= 470 &&
        item["Power Rating"] === 500 &&
        (item["Name"] === "Mini Power Wave" ||
          item["Name"] === "Micro Power Wave")
      ) {
        closetsItem.push(item);
      }

      if (item["Power Rating"] === 3000 && item["Name"] === "Power Wave 1") {
        if (this.state.totalcap <= 2700 && this.state.totalcap > 2100) {
          closetsItem.push(item);
        }
      }
    }

    var lastData = {};

    if ((this.state.totalcap >= 1500) & (this.state.totalcap <= 2700)) {
      if (
        (this.state.ivData === "120V, 1P" ||
          this.state.ivData === "277V, 1P") &&
        (this.state.ovData === "120V, 1P" || this.state.ovData === "277V, 1P")
      ) {
        lastData = closetsItem;
      } else {
        lastData = closetsItem.filter(
          (item) => item["Name"] !== "Mini Power Wave"
        );
      }
    } else {
      lastData = closetsItem;
    }

    this.setOpdatawithProduct(lastData);
  }

  setAuxBreakerConfig = (data, num, listCount) => {
    this.setState({ auxBreakerConfig: data }, () => {});
    this.setState({ numOfBreakers: num });
    this.setState({ listSize: listCount });
  };

  productModelNumber = () => {
    var myprodNum = "";
    var inOutCode = "";
    var powerRatingCode = String(
      this.state.modelNumberCode[
        String(this.state.userOPdata[this.state.modelIndex]["Power Rating"])
      ]
    );

    if (this.state.phaseTypeData === 1) {
      inOutCode =
        String(
          this.state.modelNumberCode[String(this.state.ivData) + " Input"]
        ) +
        String(
          this.state.modelNumberCode[String(this.state.ovData) + " Output"]
        );
    } else {
      inOutCode =
        String(this.state.modelNumberCode[String(this.state.ivData)]) +
        String(this.state.modelNumberCode[String(this.state.ovData) + " Out"]);
    }

    var batTypeCode = "";

    batTypeCode = String(
      this.state.modelNumberCode[String(this.state.batTypeData)]
    );

    if (this.state.custombatBUTData !== "") {
      batTypeCode = batTypeCode + this.state.custombatBUTData;

      //console.log(batTypeCode);
    }

    if (this.state.batBUTData !== "Custom") {
      batTypeCode = batTypeCode + this.state.batBUTData;
    }

    var optionsCode = "";

    Object.keys(this.state.optionList).map((item, index) => {
      if (this.state.optionList[item] === false) {
        if (item === "Load Control Relay, Single Flex Stud Mounting") {
          optionsCode =
            optionsCode +
            "+" +
            String(this.state.modelNumberCode[String(item)]) +
            "(" +
            this.state.qtyMonOption["QUANT* " + item] +
            ")";
        } else if (item === "Load Control Relay, No Flex Stud Mounting") {
          optionsCode =
            optionsCode +
            "+" +
            String(this.state.modelNumberCode[String(item)]) +
            "(" +
            this.state.qtyMonOption["QUANT* " + item] +
            ")";
        } else {
          if (optionsCode === "") {
            optionsCode = String(this.state.modelNumberCode[String(item)]);
          } else {
            optionsCode =
              optionsCode +
              "+" +
              String(this.state.modelNumberCode[String(item)]);
          }
        }
      }
      return item;
    });

    var batteryOptionCode = "";

    Object.keys(this.state.batteryList).map((item, index) => {
      if (this.state.batteryList[item] === false && batteryOptionCode === "") {
        batteryOptionCode = String(this.state.modelNumberCode[String(item)]);
      } else if (this.state.batteryList[item] === false) {
        batteryOptionCode =
          batteryOptionCode +
          "+" +
          String(this.state.modelNumberCode[String(item)]);
      }
      return item;
    });

    var monitorOptionCode = "";

    Object.keys(this.state.monitorOptions).map((item, index) => {
      if (
        this.state.monitorOptions[item] === false &&
        monitorOptionCode === ""
      ) {
        monitorOptionCode = String(this.state.modelNumberCode[String(item)]);
      } else if (this.state.monitorOptions[item] === false) {
        if (index === 0) {
          monitorOptionCode = String(this.state.modelNumberCode[String(item)]);
        } else {
          monitorOptionCode =
            monitorOptionCode +
            "+" +
            String(this.state.modelNumberCode[String(item)]);
        }
      }
      return item;
    });

    //System Transfer Code

    var systemTransferCode = "";

    Object.keys(this.state.systemTransfer).map((item) => {
      if (
        this.state.systemTransfer[item] === false &&
        systemTransferCode === ""
      ) {
        systemTransferCode = String(this.state.modelNumberCode[String(item)]);
      } else if (this.state.systemTransfer[item] === false) {
        systemTransferCode =
          systemTransferCode +
          "+" +
          String(this.state.modelNumberCode[String(item)]);
      }
      return item;
    });

    //Battery Monitoring Options
    var batteryMonitoringCode = "";

    Object.keys(this.state.batMonList).map((item) => {
      if (
        this.state.batMonList[item] === false &&
        batteryMonitoringCode === ""
      ) {
        batteryMonitoringCode = String(
          this.state.modelNumberCode[String(item)]
        );
      } else if (
        this.state.batMonList[item] === false &&
        batteryMonitoringCode !== ""
      ) {
        batteryMonitoringCode =
          batteryMonitoringCode +
          "+" +
          String(this.state.modelNumberCode[String(item)]);
      }
      return item;
    });

    //Global monitoring
    var GlobalMonitoringCode = "";
    //console.log(this.state.globMonList);
    Object.keys(this.state.globMonList).map((item) => {
      if (
        this.state.globMonList[item] === false &&
        GlobalMonitoringCode === ""
      ) {
        GlobalMonitoringCode = String(this.state.modelNumberCode[String(item)]);
      } else if (
        this.state.globMonList[item] === false &&
        GlobalMonitoringCode !== ""
      ) {
        GlobalMonitoringCode =
          GlobalMonitoringCode +
          "+" +
          String(this.state.modelNumberCode[String(item)]);
      }
      return item;
    });

    var warrantyCode = "";
    var warrArr = [];

    Object.keys(this.state.warrantyList).map((item, index) => {
      if (this.state.warrantyList[item] === false) {
        warrArr.push(this.state.modelNumberCode[String(item)]);
      }
      return item;
    });

    warrantyCode = warrArr.join("~");

    //Auxbreaker
    var auxCode = "";
    var microPWcode = "";
    var microArr = [];

    if (optionsCode !== "") {
      microArr.push(optionsCode);
    }
    if (monitorOptionCode !== "") {
      microArr.push(monitorOptionCode);
    }
    if (batteryOptionCode !== "") {
      microArr.push(batteryOptionCode);
    }

    if (microArr.listCount === 1) {
      microPWcode = String(microArr);
    } else {
      microPWcode = String(microArr.join("+"));
    }

    if (this.state.productType === "Micro Power Wave") {
      auxCode =
        this.state.auxBreakerConfig.length > 0
          ? "N(" + this.state.auxBreakerConfig[0]["Num"] + ")"
          : "";

      myprodNum =
        powerRatingCode +
        "-" +
        inOutCode +
        "-" +
        batTypeCode +
        "-" +
        microPWcode +
        "-" +
        auxCode +
        "-" +
        warrantyCode;
    }
    if (this.state.productType === "Mini Power Wave") {
      auxCode =
        this.state.auxBreakerConfig.length > 0
          ? "N(" +
            this.state.auxBreakerConfig[0]["Num"] +
            ")" +
            this.state.modelNumberCode[
              String(this.state.auxBreakerConfig[0]["V"] + " AUX")
            ]
          : "";

      myprodNum =
        powerRatingCode +
        "-" +
        inOutCode +
        "-" +
        batTypeCode +
        "-" +
        microPWcode +
        "-" +
        auxCode +
        "-" +
        warrantyCode;
    }

    if (
      this.state.productType !== "Mini Power Wave" &&
      this.state.productType !== "Micro Power Wave"
    ) {
      //console.log("not micro or mini power wave");
      //Do p1,3,4,harsh aux breaker code here
      {
        this.state.auxBreakerConfig.length > 0 &&
          Object.keys(this.state.auxBreakerConfig).map((item, index) => {
            if (index === 0) {
              auxCode =
                auxCode +
                this.state.modelNumberCode[
                  String(this.state.auxBreakerConfig[item]["O"])
                ] +
                "0" +
                this.state.auxBreakerConfig[item]["Num"] +
                this.state.modelNumberCode[
                  String(this.state.auxBreakerConfig[item]["V"])
                ] +
                this.state.auxBreakerConfig[item]["A"];
            } else {
              auxCode =
                auxCode +
                "+" +
                this.state.modelNumberCode[
                  String(this.state.auxBreakerConfig[item]["O"])
                ] +
                "0" +
                this.state.auxBreakerConfig[item]["Num"] +
                this.state.modelNumberCode[
                  String(this.state.auxBreakerConfig[item]["V"])
                ] +
                this.state.auxBreakerConfig[item]["A"];
            }

            return item;
          });
      }

      myprodNum = powerRatingCode + "-" + inOutCode + "-" + batTypeCode;

      var sampArr = [];

      if (optionsCode !== "") {
        sampArr.push(optionsCode);
      }

      if (monitorOptionCode !== "") {
        sampArr.push(monitorOptionCode);
      }

      if (batteryOptionCode !== "") {
        sampArr.push(batteryOptionCode);
      }

      if (systemTransferCode !== "") {
        sampArr.push(systemTransferCode);
      }

      if (batteryMonitoringCode !== "") {
        sampArr.push(batteryMonitoringCode);
      }

      if (GlobalMonitoringCode !== "") {
        sampArr.push(GlobalMonitoringCode);
      }

      //console.log(sampArr.join("+"));
      var codeString = "";
      if (sampArr.listCount === 1) {
        codeString = String(sampArr);
      } else {
        codeString = sampArr.join("+");
      }

      let sfb1Num = "";
      let sfb2Num = "";

      if (this.state.sfb1 !== "None") {
        sfb1Num = "+SFB1(" + String(this.state.sfb1).replace(" Amps", "") + ")";
      }
      if (this.state.sfb2 !== "None") {
        sfb2Num = "+SFB2(" + String(this.state.sfb2).replace(" Amps", "") + ")";
      }

      myprodNum =
        myprodNum +
        "-" +
        auxCode +
        (sfb1Num === "" ? "" : sfb1Num) +
        (sfb2Num === "" ? "" : sfb2Num) +
        "-" +
        codeString +
        "-" +
        warrantyCode;
    }

    //console.log(myprodNum);
    this.setState({
      myProductNumber: myprodNum,
    });
  };

  //Get View from Step state
  // Add this method to your InverterSelectorForm component
  getViewForCurrentStep(myViews) {
    const { step } = this.state;
    // Assuming 'views' is an array of components you want to render based on the current step
    const views = myViews; // Ensure you have a method or logic to define your views array

    switch (step) {
      case 2:
        return (
          <>
            {views[step]}
            {views[step + 1]}
          </>
        );
      case 6:
        return (
          <>
            {/*this.state.productType !== "Micro Power Wave" &&*/ views[step]}
            {views[step + 1]}
            {views[step + 2]}
            {views[step + 3]}
          </>
        );
      case 7:
        return views[10];
      case 8:
        return <>{views[11]}</>;
      default:
        return views[step];
    }
  }

  next = () => {
    this.setShowPrevButton(true);
    
    //alert(this.state.step , " :step next")
    if (this.state.step === 3) {
      this.setState({ step: this.state.step + 2 });
    }

    if(this.state.step === 5){

      this.setState({ showNextButton: true });

    }

    if (this.state.step === 7) {
      //call here for product code convert
      this.productModelNumber();
    }

    if (this.state.step === 6) {
      this.setShowNextButton(false);
    }

    if (this.state.productType !== "" && this.state.step === 5) {
      this.setState({ auxBreakerConfig: [] });
      this.setState({ numOfBreakers: "" });
    }

    if (this.state.step < maxViewsIndex) {
      if (
        this.state.step === 5 &&
        this.state.userOPdata[this.state.modelIndex]["Name"] ===
          "Micro Power Wave"
      ) {
        this.setState({ step: this.state.step + 1 });
      } else {
        if (this.state.step === 2) {
          this.setState({ step: this.state.step + 2 });
        } else {
          this.setState({ step: this.state.step + 1 });
        }
      }
    }
  };

  previous = () => {
    if (this.state.step === 1) {
      this.setShowPrevButton(false);
    }

    //console.log("Previous");
    //console.log(this.state.step);
    if (this.state.step === 6 && this.state.productType !== "") {
      this.setState({ productType: "" });
      //console.log("Empty product type when going back");
      //console.log("also reset ablist");
      this.setState({ auxBreakerConfig: [] });
      this.setState({ numOfBreakers: "" });
    }

    if (this.state.step > 0) {
      if (
        this.state.step === 7 &&
        this.state.userOPdata[this.state.modelIndex]["Name"] ===
          "Micro Power Wave"
      ) {
        this.setState({ step: this.state.step - 1 });
      } else {
        if (this.state.step === 4) {
          this.setState({ step: this.state.step - 2 });
        } else {
          this.setState({ step: this.state.step - 1 });
        }
      }
    }
  };

  ///Sub Feed Panel Breakers
  setSFB1 = (data, index) => {
    if (index === 1) {
      this.setState({ sfb1: data });
    }
    if (index === 2) {
      this.setState({ sfb2: data });
    }
  };

  render() {
    //Store all the views here
    const views = [
      <CapacityView
        totalcap={this.state.totalcap}
        allowTotal={this.state.allowTotal}
        wattTotal={this.state.wattTotal}
        mytotalcap={this.state.mytotalcap}
        numFixture={this.state.numFixture}
        powerRatingFilteredData={this.powerRatingFilteredData}
        saveAllowanceTotal={this.saveAllowanceTotal}
        saveMyTotalCap={this.saveMyTotalCap}
        saveNumFixture={this.saveNumFixture}
        saveWattTotal={this.saveWattTotal}
        showNextButton={this.setShowNextButton}
        showPrevButton={this.setShowPrevButton}
        next={this.next}
        previous={this.previous}
        step={this.state.step}
      />,
      <PhaseView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        showPrevButton={this.setShowPrevButton}
        phaseFilteredData={this.phaseFilteredData}
        powerRating={this.state.totalcap}
        phaseTypeData={this.state.phaseTypeData}
        data={this.state}
      />,
      <InputVoltageView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        ivData={this.state.ivData}
        singlePhase={this.state.singlePhase}
        threePhase={this.state.threePhase}
        setIVData={this.setIVData}
        totalcap={this.state.totalcap}
        data={this.state}
      />,
      <OutputVoltageView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        ovData={this.state.ovData}
        singlePhase={this.state.singlePhase}
        threePhase={this.state.threePhase}
        setOVData={this.setOVData}
        totalcap={this.state.totalcap}
        data={this.state}
      />,
      <EnclosureView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        phaseType={this.state.phaseType}
        cabType={this.state.cabType}
        shakerData={this.state.shakerData}
        shakerTableFilteredData={this.shakerTableFilteredData}
        cabinetFilteredData={this.cabinetFilteredData}
        shakerTable={this.state.shakerTable}
        ivData={this.state.ivData}
        ovData={this.state.ovData}
        totalcap={this.state.totalcap}
        phaseTypeData={this.state.phaseTypeData}
        fieldSelectableVoltOption={this.fieldSelectableVoltOption}
        fieldSelectableVoltdata={this.state.fieldSelectableVoltdata}
      />,
      <ModelSeriesSelectView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        userOPdata={this.state.userOPdata}
        setProductType={this.setProductType}
        productType={this.state.productType}
        data={this.state}
      />,
      <BatterySelectView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        setbatBUTData={this.setbatBUTData}
        setbatTypeData={this.setbatTypeData}
        custombatBUTData={this.state.custombatBUTData}
        setCustombatBUTData={this.setCustombatBUTData}
        batBUTData={this.state.batBUTData}
        batTypeData={this.state.batTypeData}
        data={this.state}
      />,
      <AuxBreakerView
        next={this.next}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        userOPdata={this.state.userOPdata}
        setAuxBreakerConfig={this.setAuxBreakerConfig}
        auxBreakerConfig={this.state.auxBreakerConfig}
        setShowNextButton={this.setShowNextButton}
        numOfBreakers={this.state.numOfBreakers}
        listSize={this.state.listSize}
        data={this.state}
        setSFB1={this.setSFB1}
      />,
      <OptionSelectView
        optionList={this.state.optionList}
        batteryList={this.state.batteryList}
        monitorOptions={this.state.monitorOptions}
        batMonList={this.state.batMonList}
        systemTransfer={this.state.systemTransfer}
        globMonList={this.state.globMonList}
        qtyMonOption={this.state.qtyMonOption}
        setOptionsList={this.setOptionsList}
        setGlobalMonList={this.setGlobalMonList}
        setBatMonOptionsList={this.setBatMonOptionsList}
        setSystemTransfer={this.setSystemTransfer}
        setBatOptionsList={this.setBatOptionsList}
        setMonOptionsList={this.setMonOptionsList}
        setQtyMonOptionsList={this.setQtyMonOptionsList}
        next={this.next}
        previous={this.previous}
        setshowNextButton={this.setShowNextButton}
        data={this.state}
      />,
      <WarrantySelectView
        next={this.next}
        previous={this.previous}
        warrantyList={this.state.warrantyList}
        setWarrantyList={this.setWarrantyList}
        showNextButton={this.setShowNextButton}
      />,
      <SignUpEmailView
        next={this.next}
        setProfileData={this.setProfileData}
        previous={this.previous}
        showNextButton={this.setShowNextButton}
        profileData={this.state.profileData}
        data={this.state}
      />,
      <DetailedUserDataView
        next={this.next}
        previous={this.previous}
        data={this.state}
        opData={this.state.userOPdata}
        productType={this.state.productType}
        totalcap={this.state.totalcap}
        cabType={this.state.cabType}
        myProductNumber={this.state.myProductNumber}
        showNextButton={this.setShowNextButton}
      />,
    ];

    return (
      //App starts here
      <Paper elevation={0} className="Paper-main">
        <HeaderView />

        {this.state.userOPdata &&
          this.state.userOPdata.length > 0 &&
          (this.state.step === 6 || this.state.step === 7) && (
            <ProgressSteps data={this.state} />
          )}

        <Box
          className="Box-main"
          sx={{
            display: "flex",
            "& > :not(style)": {
              m: 1,
              width: "100%",
              height: "60%",
              maxWidth: "900px",
            },
            flexWrap: "wrap",
            justifyContent: "center",
            "@media (max-width: 700px)": {
              width: "100%", // Set width to 100% on mobile screens
              maxWidth: "100%",
            },
          }}
        >
          {/* Cap total card  */}
          {/*Render whichver view goes here*/}
          {this.getViewForCurrentStep(views)}
        </Box>
        {this.state.step < 8 ? (
          <NavRow
            next={this.next}
            previous={this.previous}
            showNextButton={this.state.showNextButton}
            showPrevButton={this.state.showPrevButton}
            step={this.state.step}
          />
        ) : (
          ""
        )}
        {/* {this.state.step} */}
      </Paper>
    );
  }
};

// export default withStyles(styles) (InverterSelectorForm);
export default (InverterSelectorForm);
